declare global {
  interface JQuery {
    modal(action?: string | object): JQuery;
  }
}

import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

import VisiblePassword from '../../components/visiblePassword.js'
import FlashMessages from '../../components/flashMessages.js';
import {_printDate, _printNumber, _printShortFullDate} from '../../helpers/helpers.js'

// https://www.freecodecamp.org/news/how-to-implement-vertical-scrolling-in-react-using-react-router-hash-link/
import { HashLink } from 'react-router-hash-link';

import {RtUserAccountPageResult} from '../../../../server/routes/user.js'

interface AccountProps {
    server: string;
    pageData: unknown;
}

interface ComponentProps {
    props: RtUserAccountPageResult;
}

export default function Account({server, pageData}: AccountProps) {

	let [data, setData] = useState(pageData as RtUserAccountPageResult);

	return (<>
        <AccountPanel props={data} />
        <PasswordChangeModal props={data} />
        <ConfirmDeleteAccountModal props={data} />
        <APIKeyGeneration props={data} />
        <ResultOfOperationModal props={data} />
    </>)
}

function AccountPanel({props}: ComponentProps){

    return (<>
        <section className="section section-lg">
            <div className="container">
                <div className="row row-50">
                    <div className="col-md-8 col-lg-8 col-xl-8">
                        <FlashMessages props={props} />
                        <h2>
                            Account
                        </h2> detailed account information
                        <div className="row row-50">
                            <div className="col-12">
                                <table className="table-custom table-custom-striped table-custom-primary" style={{color: 'black'}}>
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td>{props.Name}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>{props.Email}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Login type</td>
                                            <td>{props.AuthType}
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Account since</td>
                                            <td>{_printShortFullDate(props.DateOpened)}</td>
                                            <td></td>
                                        </tr>
                                        {
                                            props.HasPassword &&
                                            <tr>
                                                <td>Password</td>
                                                <td> *********{'  '}
                                                </td>
                                                <td>
                                                    <button 
                                                            type="button" 
                                                            className="btn btn-primary btn-sm" 
                                                            onClick={showChangePasswordDialog}
                                                    >
                                                            Change
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                         <tr>
                                            <td>API Key</td>
                                            <td>
                                                {
                                                !props.APIKey ? 
                                                    <>Not Generated</>                                                   
                                                    :
                                                    <>*********{'  '} (Generated on {_printShortFullDate(props.APIKey.GenerationDate)})</>
                                                }
                                            </td>
                                            <td>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-primary btn-sm" 
                                                    data-toggle="modal" 
                                                    data-target="#modalAPIKey"
                                                >
                                                    {props.APIKey ? "Regenerate" : "Generate"}
                                                </button>
                                            </td>
                                        </tr>                                       
                                        <tr>
                                            <td>Subscription</td>
                                            <td>
                                            {
                                                !!props.Subscription ?
                                                <>
                                                    <div>
                                                        Type: {props.Subscription.Type}
                                                    </div>
                                                    <div>
                                                        Status: {props.Subscription.Status}
                                                    </div>
                                                    <div>
                                                        Recurring Period: {props.Subscription.RecurringPeriod}
                                                    </div>
                                                    <div>
                                                        Started: {_printShortFullDate(props.Subscription.StartDate)}
                                                    </div>
                                                </>
                                                    :
                                                <>
                                                    {
                                                        props.PendingSubscription ? 
                                                        <>
                                                            Pending Approval
                                                        </>
                                                        :
                                                        <>
                                                            None
                                                        </>
                                                    }
                                                </>
                                            }
                                            </td>
                                            <td>
                                            {
                                                props.Subscription ?
                                                <>
                                                {/*
                                                <button 
                                                    type="button" 
                                                    className="btn btn-primary btn-sm" 
                                                    data-toggle="modal" 
                                                    data-target="#modalConfirm"
                                                >
                                                    Cancel
                                                </button>
                                                */}
                                                </>
                                                :
                                                <HashLink  smooth
                                                    to="/pricing#plans"
                                                    className="btn btn-primary btn-sm" 
                                                    role="button" 
                                                >
                                                    Subscribe
                                                </HashLink>
                                            }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Credits</td>
                                            <td>
                                                {
                                                    !!props.PendingCredits ?
                                                    <>
                                                        Available: {` ${_printNumber(props.Credits)}`}
                                                        <br/>
                                                        Pending Approval: {` ${_printNumber(props.PendingCredits)}`}
                                                    </>
                                                    :
                                                    <>
                                                        {_printNumber(props.Credits)}
                                                    </>
                                                }
                                            </td>
                                            <td>
                                                <HashLink  smooth 
                                                    to="/pricing#credits"
                                                    className="btn btn-primary btn-sm" 
                                                    role="button" 
                                                >
                                                        {props.Credits ? "Buy More" : "Buy"}
                                                </HashLink>
                                            </td>
                                        </tr>                                        
                                        <tr>
                                            <td>Verified Domains</td>
                                            <td>{_printNumber(props.VerifiedDomainCount)}</td>
                                            <td>
                                                <Link 
                                                    className="btn btn-primary" 
                                                    title='List of Verified Domains'
                                                    to={'/user/verified-domains'}
                                                >
                                                    Verified Domains
                                                </Link>
                                            </td>
                                        </tr>                                        
                                        <tr>
                                            <td>Monitored Websites</td>
                                            <td>{_printNumber(props.MonitoredWebsiteCount)}</td>
                                            <td>
                                                <Link 
                                                    className="btn btn-primary" 
                                                    title='Monitored Websites list'
                                                    to={'/monitoring/websites'}
                                                >
                                                    Monitored Websites
                                                </Link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Reports</td>
                                            <td>
                                                <ul>   
                                                    {
                                                        !!props.PendingReportCount &&
                                                        <li style={{backgroundColor: '#f9f8f8'}}>
                                                            Pending Approval: 
                                                        </li>
                                                    }                                          
                                                    {
                                                        !!props.Reports.length && 
                                                        <>
                                                            {
                                                                props.Reports.map((report, indexKey) => {
                                                                    let color = (indexKey % 2) ? '#f9f8f8' : '#f0f0f0';
                                                                    return (
                                                                        <li key={report.id} style={{backgroundColor: color}} >
                                                                            {_printShortFullDate(report.date)}: {report.name} 
                                                                        </li>
                                                                        )
                                                                    })
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        props.Reports.length == 0 && props.PendingReportCount == 0 &&
                                                        <>None</>
                                                    }
                                                </ul>   
                                            </td>
                                            <td>
                                                <ul>
                                                    {
                                                        !!props.PendingReportCount &&
                                                        <li style={{backgroundColor: '#f9f8f8'}}>
                                                           {` ${_printNumber(props.PendingReportCount)}`} report(s)
                                                        </li>
                                                    }  
                                                    { 
                                                        !!props.Reports.length && 
                                                        <>
                                                            {
                                                                props.Reports.map((report, indexKey) => {
                                                                let color = (indexKey % 2) ? '#f9f8f8' : '#f0f0f0';
                                                                return (
                                                                    <li key={report.id}  style={{backgroundColor: color}}>
                                                                        <a href={`/reports/${report.id}/download`} 
                                                                        className="link-hover"
                                                                        >
                                                                            <b>download</b>
                                                                        </a>
                                                                    </li>
                                                                    )
                                                                })
                                                            }
                                                        </> 
                                                    }                                                    
                                                    {
                                                        props.Reports.length == 0 && props.PendingReportCount == 0 &&
                                                        <>{' '}</>
                                                    }
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Orders</td>
                                            <td>
                                                {
                                                props.Orders.length ? 
                                                <ul>
                                                {
                                                    props.Orders.map((order, indexKey) => {
                                                        let color = (indexKey % 2) ? '#f9f8f8' : '#f0f0f0';
                                                    //    let text = (order.status == 'approved') ? order.name : `${order.name} (${order.status})`;
                                                    return (
                                                        <li key={order.id}  style={{backgroundColor: color}}>
                                                            {_printShortFullDate(order.date)}: {order.name}
                                                        </li>
                                                        )
                                                    })
                                                }
                                                </ul>
                                                :
                                                <>
                                                    None
                                                </>
                                                }
                                            </td>
                                            <td> 
                                            {
                                                props.Orders.length ? 
                                                <ul>
                                                {
                                                    //color: 'black',
                                                    props.Orders.map((order, indexKey) => {
                                                        let color = (indexKey % 2) ? '#f9f8f8' : '#f0f0f0';
                                                    return (
                                                        <li key={order.id}  style={{backgroundColor: color}}>
                                                            {
                                                                !!order.receiptURL ?
                                                                <a href={order.receiptURL} target="_blank"
                                                                    className="link-hover"
                                                                    >
                                                                    <b>view receipt</b>
                                                                </a>
                                                                :
                                                                <>{order.status}</>                              
                                                            }
                                                        </li>
                                                        )
                                                    })
                                                }
                                                </ul>
                                                : 
                                                <> { ' '}</>
                                                }                                                                                              
                                            </td>
                                        </tr>                                        
                                    </tbody>
                                </table>
                                <br/>
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    data-toggle="modal" 
                                    data-target="#modalConfirm"
                                >
                                    Delete Account
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    </>)
}

function PasswordChangeModal({props}: ComponentProps) {
    return (<>
    
    <div className="modal fade" id="modalChangePassword" tabIndex={-1} role="dialog" aria-labelledby="modalChangePasswordLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="modalChangePasswordLabel"><strong>Password Change</strong></h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <form action="/user/login" method="POST">
                        <div className="form-group">
                            <label htmlFor="old password">Old Password</label>
                            <input
                                type="password"
                                id="oldpassword"
                                name="oldpassword"
                                className="form-control"
                                placeholder="Enter Old Password"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">New Password</label>
                            <VisiblePassword id={"password"} />
                        </div>
                    </form>            
                    <div id="msgDiv"></div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button 
                        type="button" 
                        className="btn btn-danger btn-sm" 
                        id="btn-delete-website"
                        onClick={handleChangePasswordClick}
                    >
                            Change Password
                    </button>
                </div>
                </div>
            </div>
        </div>
    
    </>)
}

function ConfirmDeleteAccountModal({props}: ComponentProps) {
    return (<>
        <div className="modal fade" id="modalConfirm" tabIndex={-2} role="dialog" aria-labelledby="modalConfirmLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalConfirmLabel">Please Confirm</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        Are you sure you want to delete the account? Once account is deleted all the data is lost.
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            data-dismiss="modal" 
                            id="btn-delete-account"
                            onClick={handleDeleteAccount}
                        >
                                Delete Account
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)    
}

function APIKeyGeneration({props}: ComponentProps) {

    return (<>
        <div className="modal fade" id="modalAPIKey" tabIndex={-2} role="dialog" aria-labelledby="modalAPIKeyLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalAPIKeyLabel">Please Confirm</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    Before proceeding, please confirm that you wish to generate a new API key. Once created, the old key will no longer be valid.
                    </div>
                    <div id="msgDiv"></div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            data-dismiss="modal" 
                            id="btn-generate-api-key"
                            onClick={handleAPIKeyClick}
                        >
                                Generate API Key
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)    
}

function ResultOfOperationModal({props}: ComponentProps) {

    return (<>
        <div className="modal fade" id="modalResult" tabIndex={-2} role="dialog" aria-labelledby="modalResultLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalResultLabel"></h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <div id="dialogMessage"></div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

function showChangePasswordDialog(evt: React.MouseEvent<HTMLButtonElement>) {

    $('#msgDiv').html('');
    $('#oldpassword').val('');
    $('#password').val('');

    $('#modalChangePassword').modal('show');
}

function handleChangePasswordClick(evt: React.MouseEvent<HTMLButtonElement>)
{
    evt.preventDefault();

    $('#msgDiv').html('Processing request ...')
    const oldPassword = $('#oldpassword').val();
    const newPassword = $('#password').val();

    return fetch('/user/change-password/api', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
            currentPassword: oldPassword,
            newPassword: newPassword
        })
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            // hide modal window
            $('#modalChangePassword').modal('hide');

            // show result window
            $('#modalResultLabel').text('Password Changed');
            $('#dialogMessage').text('Your password has been successfully changed!');
            $('#modalResult').modal('show');
        } 
        else {
            $('#msgDiv').html(
                `<div className="alert alert-danger" role="alert">
                    ${data.msg}
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                `);
        }
    });
}


function handleAPIKeyClick(evt: React.MouseEvent<HTMLButtonElement>)
{
    evt.preventDefault();

    $('#msgDiv').html('Processing request ...')

    return fetch('/user/generate-api-key/api', {
        method: 'GET',
        headers: { 'Content-type': 'application/json' }
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            // hide modal window
            $('#modalAPIKey').modal('hide');

            // show result window
    $('#modalResultLabel').text('New API Key was generated');
    $('#dialogMessage').text('An email with the new API key was sent to you!');
            $('#modalResult').modal('show');
        } 
        else {
            $('#msgDiv').html(
                `<div className="alert alert-danger" role="alert">
                    ${data.msg}
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                `);
        }
    });
}

function handleDeleteAccount(): void {
    window.location.href = "/user/delete";
}